<template>
  <div>
    <section class="section section-lg pt-lg-0">
      <div class="container">
        <br />
        <br />
        <br />
        <div class="row">
          <card class="border-0" shadow body-classes="py-5">
            <h1 class="display-3 text-black">
              List Transaksi - Pelayanan Pajak BPHTB
              <span>Kota Tarakan</span>
            </h1>
            <hr>
            <br />
            <b-row>
              <b-col lg="12" class="my-1">
                <div class="btn-wrapper float-right">
                  <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="white" icon="fa fa-arrow-left"
                    @click="goback()">Kembali</base-button>
                  <base-button tag="a" class="mb-3 mb-sm-0" type="success" textColor="white" icon="fa fa-plus"
                    @click="newRegister()">Tambah</base-button>
                </div>
              </b-col>
              <b-col lg="6">
                <b-form-group :label="false">
                  <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter" type="search"
                      placeholder="Ketik disini untuk mencari data Anda">
                    </b-form-input>
                    <b-input-group-append>
                      <base-button tag="a" class="mb-3 mb-sm-0" type="warning" textColor="white" icon="fa fa-reset"
                        :disabled="!filter" @click="filter = ''">Reset</base-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12" class="my-1">
                <b-table :bordered="true" :small="true" :hover="true" :items="items" :fields="fields"
                  :head-variant="'light'" :busy.sync="isBusy" :per-page="perPage" :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm" :filter="filter"
                  @filtered="onFiltered" :tbody-tr-class="rowClass">
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(status)="row">
                    {{
                      row.item.status == 0
                      ? "Belum Verifikasi 1"
                      : row.item.status == 1
                        ? "Belum Verifikasi 2"
                        : row.item.status == 2
                          ? "Belum Verifikasi 3"
                          : row.item.status == 3
                            ? "Belum Bayar"
                            : row.item.status == 4
                              ? "Lunas"
                              : row.item.status == 5
                                ? "Perbaikan (silahkan klik edit)"
                                : "-"
                    }}
                  </template>
                  <template #cell(actions)="row">
                    <div v-if="loading">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <div class="row row-grid" style="padding-left: 20px;padding-right: 20px;" v-else>
                      <base-button outline size="sm" variant="default"
                        style="cursor: pointer; border-color: black; margin-bottom: 2px;"
                        @click="cetakPendaftaran(row.item.id)">
                        <i class="fa fa-print"></i> Cetak Pendaftaran
                      </base-button>
                      <template v-if="row.item.status == 0 || row.item.status == 5
                        ">
                        <base-button outline size="sm" variant="default"
                          style="cursor: pointer; border-color: black;margin-bottom: 2px;" @click="edit(row.item)">
                          <i class="fa fa-pencil"></i> Edit
                        </base-button>
                      </template>

                      <template v-if="row.item.status == 3
                        ">
                        <base-button size="sm" outline type="default" v-if="row.item.pajak_bphtb <= 10000000"
                          style="cursor: pointer; border-color: black;margin-bottom: 2px;"
                          @click="printQRCode(row.item.id)">
                          <i class="fa fa-qrcode"></i> Bayar via QR
                        </base-button>
                        <base-button outline size="sm" type="default"
                          style="cursor: pointer;  border-color: black;margin-bottom: 2px;"
                          @click="printKodeBayar(row.item.id)">
                          <i class="fa fa-credit-card"></i> Bayar via VA
                        </base-button>
                      </template>
                      <base-button outline v-if="row.item.status == 4
                        " size="sm" type="default" style="cursor: pointer; border-color: black;margin-bottom: 2px;"
                        @click="printSspd(row.item)">
                        <i class="fa fa-print"></i> SSPD
                      </base-button>
                      <base-button outline v-if="row.item.status == 4
                        " size="sm" type="default" style="cursor: pointer; border-color: black;margin-bottom: 2px;"
                        @click="printNtpd(row.item.id)">
                        <i class="fa fa-print"></i> NTPD
                      </base-button>
                    </div>
                  </template>
                </b-table>

              </b-col>
            </b-row>
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
              aria-controls="my-table"></b-pagination>
          </card>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import {
  BTable,
  BTr,
  BTh,
  BPagination,
  BRow,
  BCol,
  BInputGroup,
  BFormGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "walet",
  components: {
    BTable,
    BTr,
    BTh,
    PulseLoader,
    BPagination,
    BRow,
    BCol,
    BInputGroup,
    BFormGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
  },
  data() {
    return {
      filter: "",
      sortBy: "id",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      loading: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "full_no_urut_pelayanan",
          sortable: false,
          label: "No.Pelayanan",
          class: "text-center",
          sortByFormatted: false,
          thClass: "text-center",
        },
        {
          key: "nop",
          sortable: false,
          label: "NOP",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "nama_pemilik",
          sortable: false,
          label: "Nama Pemilik",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "nama",
          sortable: false,
          label: "Nama Wajib Pajak",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "thn_pajak",
          sortable: false,
          label: "Tahun Pajak",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "tgl_bayar",
          sortable: false,
          label: "Tanggal Bayar",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "nama_sk",
          sortable: false,
          label: "Jenis SK",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "status",
          label: "Verifikasi",
        },
        {
          key: "actions", label: "Aksi",
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 5) return 'table-danger'
      if (item.status === 4) return 'table-success'
    },
    printNtpd(id) {
      this.loading = true;
      axios({
        url: "/api/v1/bphtb/ntpd?id=" + id, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", 'NTPD_' + id + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => {
        this.loading = false;
      });
    },
    printQRCode(id) {
      this.$router.push("/payment/qrcode/" + id);
    },
    printKodeBayar(id) {
      this.$router.push("/payment/vacode/" + id);
    },
    cetakPendaftaran(id) {
      this.loading = true;
      axios({
        url: "/api/v1/bphtb/cetak-pendaftaran?id=" + id, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", 'PENDAFTARAN_' + id + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => {
        this.loading = false;
      });
    },
    goback() {
      this.$router.go(-1);
    },
    newRegister() {
      this.$router.push("/bphtb/from-daftar");
    },
    edit(items) {
      this.$router.push("/bphtb/from-update/" + items.id);
    },
    printSspd(items) {
      try {
        const me = this;
        this.loading = true;
        axios({
          url:
            "/api/v1/bphtb/sspd" +
            "?id=" +
            items.id,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "SSPD_" + items.id + ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
          });
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async getItems() {
      this.items = [];
      this.isBusy = true;
      try {
        let { data } = await axios.get("/api/v1/bphtb/pelayanan");
        this.items = data;
        this.totalRows = this.items.length;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  max-width: max-content;
  padding-left: 20px;
  padding-right: 20px;
}

.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card {
  width: 100% !important;
}
</style>